module.exports = __webpack_public_path__ + "img/DocumentDataInactive.04ed9d48.svg";